export const getters = {
  users (state) {
    return state.users
  },
  user (state) {
    return state.user
  }
}
